export default function(){
    if(window.loading){
    window.loading.forEach(l=>l.remove());
    window.loading=[];
    }
}